import React, { useEffect, useState } from 'react'
import UploadList from './UploadList';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import { useSelector } from 'react-redux';
import { getExcelPoFileReducer } from '../../../../../../redux/reducers/reducerSlices/ExcelPoFileReducer';

const ExcelFileUploadStatusList = (props) => {
    const { themeSelected,sessionId,setShowSessionData } = props;
    const [typeShow,setTypeShow]=useState("success");
      const excelPoFileData = useSelector(getExcelPoFileReducer);
      const { successFailedData,loading } = excelPoFileData;
    const [uploadSuccessData,setUploadSuccessData]=useState( []);
    const [uploadFailData,setUploadFailData]=useState([]);    
    const divRef = React.useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {   
        if (sessionId) {
        dispatch({ type: sagaActions.SUCCESS_FAILED_DATA_BY_SESSIONID, payload: { sessionId: sessionId } });
        }
    },[sessionId])

    useEffect(() => {
      if (successFailedData) {
        setUploadSuccessData(successFailedData.success || []);  
        setUploadFailData(successFailedData.failed || []);      
      }
    }, [successFailedData]);


  return (
    <>
    <div className="mt-3" ref={divRef}>
        <nav className={`d-navbar navbar navbar-expand ${themeSelected}`}>
          <div className="container-fluid">
            <div className="navbar-expand w-100 d-flex" id="navbarNav">
                <div className="d-flex align-items-center f-16" onClick={() => setShowSessionData(false)} style={{cursor:"pointer"}}>
                  <span className="font-default me-3 ">
                    <i className="fa-solid fa-arrow-left"></i> </span>
                </div>
              <ul className="navbar-nav d-flex flex-row flex-wrap">
                <li
                   className={typeShow==="success"?"d-nav nav-item px-1 mainNavigationBar d-nav-active":"d-nav nav-item px-1 mainNavigationBar"}
                  style={{ cursor: "pointer" }}
                  onClick={() => setTypeShow("success")}
                >
                   Success List
                </li>
                <li
                 className={typeShow==="failed"?"d-nav nav-item px-1 mainNavigationBar d-nav-active":"d-nav nav-item px-1 mainNavigationBar"}
               
                  style={{ cursor: "pointer" }}
                  onClick={()=>setTypeShow("failed")}
                >
                  Failed List
                </li>
              </ul>
            </div>
          </div>
        </nav>
        {typeShow==="success"?<UploadList   bodyData={uploadSuccessData} type={typeShow} themeSelected={themeSelected} loading={loading}/>:<UploadList  bodyData={uploadFailData} type={typeShow} themeSelected={themeSelected} loading={loading}/>
        }
        
      </div>
    </>
  )
}

export default ExcelFileUploadStatusList